export const GENERATE_PDF_CONSTANTS = {
  BUTTON: {
    ACCEPT: "Aceptar",
    CANCEL: "Cancelar",
    SAVE_PDF: "Guardar PDF"
  },
  LABELS: {
    MEDICAL_CONSULTATION: "Seleccione la plantilla de consulta médica",
    INFO_GROUP: "Selecciona el grupo de información"
  },
  TITLES: {
    INFO_PATIENT: "Informacion del paciente",
    TITLE: "Generar PDF",
    DOCTOR_INFO: "Información del doctor",
    SELECT_FORMS: "Seleciona los formularios que deseas incluir en el pdf",
    HELPER_TEXT: "1. Selecciona los campos que quieres visualizar",
    HELPER_TEXT_DND: "2. Ordena los campos arrastrando y soltando",
    EMPTY_TITLE: "No se encontraron formularios completados",
    PREVIEW_TITLE: "Exportar resumen en pdf"
  },
  MESSAGES: {
    ERROR_GET_TEMPLATES_PDF: "Ocurrio un error al obtener las plantillas PDF.",
    ERROR_GET_INFO_GROUPS:
      "Ocurrio un error obteniendo los grupos de informacion.",
    ERROR_GET_DETAIL_INFO_GROUP:
      "Ocurrio un error obteniendo los grupos de informacion.",
    ERROR_GET_SERVICE: "Ocurrio un error al obtener los datos del servicio",
    ERROR_GET_DETAILS_GI:
      "Ocurrio un error al obtener los detalles del grupo de información",
    TEMPLATE_PDF_REQUIRED: "La plantilla de consulta medica es obligatoria",
    IG_PATIENT_REQUIRED: "La información del paciente es obligatoria",
    IG_DOCTOR_REQUIRED: "La información del doctor es obligatoria",
    FORMS_SELECTED_REQUIRED: "Debes selecionar al menos un formulario",
    ERROR_SAVE_PDF: "Ocurrio un error al guardar el pdf.",
    SAVE_PDF: "Se ha guardado el pdf en los documentos.",
    ERROR_DETAIL_TEMPLATE_PDF:
      "Ocurrio un error obteniendo los detalles de la plantilla pdf",
    ERROR_USER_INFO: "Ocurrio un error al obtener informacion del usuario",
    FIELD_NOT_FOUND: "No se encontro ningun campo por este nombre"
  }
};

export const RENDER_OPTIONS = {
  nit: "NIT 123455654",
  logo: "logo",
  companyName: "Neumomed",
  phone: "3213405550",
  address: "Calle 79 sur # 20-02"
};

export const LABELS_GENERATE_PDF = {
  SERVICE: "Servicio ",
  SERVICE_DATE: "Fecha de servicio: ",
  PRINT_DATE: "Fecha de generación: ",
  DOCTOR_INFO: "Información del doctor: ",
  PATIENT_INFO: "Información del paciente: ",
  LOADING: "Cargando ",
  CLINICAL_CONSULTATION: "Consulta clinica:"
};

export const FORMS_STATES = {
  COMPLETE: "Completo"
};

export const METHODS = {
  CHOOSEN_FIELD: "choosenField",
  CLOSE_PREVIEW: "closePreview",
  OPEN_MODAL: "openModal",
  REFRESH_DATA: "refreshData",
  EMIT_FIELDS_SELECTED: "emitFieldsSelected",
  CLOSE_MODAL: "closeModal",
  OPEN_PREVIEW: "openPreview"
};

export const ELEMENT_TO_CONVERT = "element-to-convert";
export const DEFAULTTYPEIMG = "PNG";
export const MINUSWIDTH = 310;
export const MINUSHEIGHT = 0.9;

export const DRAG_OPTIONS = {
  animation: 0,
  group: "description",
  disabled: false,
  ghostClass: "ghost"
};
